<template>
  <v-card>
    <v-card-title></v-card-title>
    <v-card-text class="d-flex flex-column overflow-y-auto pa-0" style="height: 70vh; align-items: center">
      <v-col class="flex-grow-0">
        <v-textarea outlined
                    dense
                    hide-details
                    auto-grow
                    no-resize
                    label="Center Header"
                    v-model="center_header"></v-textarea>
      </v-col>
      <v-col class="flex-grow-0">
        <v-text-field outlined
                      dense
                      hide-details
                      label="Left Header"
                      v-model="left_header"></v-text-field>
      </v-col>
      <v-col class="flex-grow-0">
        <v-text-field outlined
                      dense
                      hide-details
                      label="Left Footer"
                      v-model="left_footer"></v-text-field>
      </v-col>
      <v-col class="flex-grow-0">
        <v-text-field outlined
                      dense
                      hide-details
                      label="Page No. Prefix"
                      v-model="page_no_prefix"></v-text-field>
      </v-col>
      <v-col class="flex-grow-0">
        <v-text-field outlined
                      dense
                      hide-details
                      type="number"
                      min="1"
                      label="Starting Page No."
                      v-model="starting_page_no"></v-text-field>
      </v-col>
      <v-col class="flex-grow-0">
        <v-text-field outlined
                      dense
                      hide-details
                      label="Right Footer"
                      v-model="right_footer"></v-text-field>
      </v-col>
      <v-col class="flex-grow-0">
        <v-text-field outlined
                      dense
                      hide-details
                      label="Center Footer"
                      v-model="center_footer"></v-text-field>
      </v-col>
<!--      <PdfPreview v-for="section in sections"-->
<!--                  :section-id="section.id"-->
<!--                  style="visibility: hidden;"></PdfPreview>-->
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('close') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="exportPdf"
             large>
        EXPORT
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import PdfPreview from "@/views/PdfPreview";
import {ACTION_TYPES} from "@/store/types";
import {onMounted, ref} from "@vue/composition-api";

export default {
  name: 'ContractASorPreviewModal',
  components: {PdfPreview},
  props: {
    sorId: String,
    aSor: Object,
  },
  setup(props, {root, emit}) {
    const center_header = ref(null);
    const left_header = ref(null);
    const left_footer = ref(null);
    const page_no_prefix = ref(null);
    const starting_page_no = ref(1);
    const right_footer = ref(null);
    const center_footer = ref(null);
    const sections = ref([]);
    const getSections = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/section/',
        params: {
          filters: {'sor.id': props.sorId},
          page_size: -1,
        },
      });

      if (response.body.success) {
        sections.value = response.body.sections;
      }
    }

    const exportPdf = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/contract/a_sor/export_pdf/',
        params: {
          sor_id: props.sorId,
          center_header: center_header.value,
          left_header: left_header.value,
          left_footer: left_footer.value,
          page_no_prefix: page_no_prefix.value,
          starting_page_no: starting_page_no.value,
          right_footer: right_footer.value,
          center_footer: center_footer.value,
        },
        opt: {extra: {responseType: 'arraybuffer'}},
      });

      let blob = new Blob([response.data], {type: response.headers.get('content-type')});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = response.headers.get('file-name') || 'export.pdf';
      link.click();

      emit('submit', true);
    }
    const collectHeights = async function () {
      let heights = {
        'sub_section_header': {},
        'sub_section_category_header': {},
        'sub_sub_section': {},
      };
      const targets = [
        {cls: 'pdf-preview-sub-section-header', attribute: 'sub_section_header'},
        {cls: 'pdf-preview-sub-section-category-header', attribute: 'sub_section_category_header'},
        {cls: 'sub-sub-section', attribute: 'sub_sub_section'},
      ];

      targets.forEach((a) => {
        let elements = [...document.body.getElementsByClassName(a.cls)];

        elements.forEach((e) => {
          heights[a.attribute][e.id] = e.offsetHeight;
        })
      });

      // console.log(heights);

      let sub_sections = {};
      _.forEach(heights.sub_section_header, (value, key) => {
        sub_sections[key] = {
          header: value,
          category: heights.sub_section_category_header[key]
        };
      })

      let sub_sub_sections = {};
      _.forEach(heights.sub_sub_section, (value, key) => {
        sub_sub_sections[key] = value + 16;
      })

      let params = {
        sub_sections,
        sub_sub_sections,
      }

      // console.log(params);

      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/contract/a_sor/set_heights/',
        params,
      });

      if (response.body.success) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/contract/a_sor/export_pdf/',
          params: {
            sor_id: props.sorId,
            center_header: center_header.value,
            left_header: left_header.value,
            left_footer: left_footer.value,
            page_no_prefix: page_no_prefix.value,
            starting_page_no: starting_page_no.value,
            right_footer: right_footer.value,
            center_footer: center_footer.value,
          },
          opt: {extra: {responseType: 'arraybuffer'}},
        });

        let blob = new Blob([response.data], {type: response.headers.get('content-type')});
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = response.headers.get('file-name') || 'export.pdf';
        link.click();

        emit('submit', true);
      }
    }

    onMounted(() => {
      center_header.value = props.aSor.center_header || '';
      left_header.value = props.aSor.left_header || '';
      left_footer.value = props.aSor.left_footer || '';
      page_no_prefix.value = props.aSor.page_no_prefix || '';
      right_footer.value = props.aSor.right_footer || '';
      center_footer.value = props.aSor.center_footer || '';

      // getSections();
    })

    return {
      center_header,
      left_header,
      left_footer,
      page_no_prefix,
      starting_page_no,
      right_footer,
      center_footer,
      sections,
      exportPdf,
      // collectHeights,
    }
  }
}
</script>
